import PageHero from "@/components/feature/PageHero";
import Greeting from "./components/Greeting";
import Teachers from "./components/Teachers";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function About() {
  return (
    <>
      <PageHero page="about" />
      <Greeting />
      <Teachers />
      <ConsultCTA />
    </>
  );
}